import React from "react";
import ToggleCreator from "../../components/Forms/components/ToggleCreator";
import SelectCreator from "../../components/Forms/components/SelectCreator";
import TimezoneList from "../../constants/timezones.json";

const Settings = (props) => {
  const {profile, handleChange} = props;
  const {settings} = profile;
  const {notify_email, timezone} = settings;

  return (
    <div>
      <h2>Notifications</h2>
      <ToggleCreator
        label={"Email"}
        help_text={"Enable email notifications"}
        colSize={3}
        checked={notify_email}
        name={"notify_email"}
        onChange={handleChange}
      />
      <h2>Miscellaneous</h2>
      <SelectCreator
        label={"Timezone"}
        options={TimezoneList}
        colSize={12}
        help_text={"Update your timezone"}
        value={timezone}
        name={"timezone"}
        onChange={handleChange}
        isSearchable
      />
    </div>
  );
};

export default Settings;
